/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteTimeAndMaterialProjectRequest
 */
export interface CompleteTimeAndMaterialProjectRequest {
    /**
     * Admin comment on complete on the behalf of the client
     * @type {string}
     * @memberof CompleteTimeAndMaterialProjectRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the CompleteTimeAndMaterialProjectRequest interface.
 */
export function instanceOfCompleteTimeAndMaterialProjectRequest(value: object): value is CompleteTimeAndMaterialProjectRequest {
    return true;
}

export function CompleteTimeAndMaterialProjectRequestFromJSON(json: any): CompleteTimeAndMaterialProjectRequest {
    return CompleteTimeAndMaterialProjectRequestFromJSONTyped(json, false);
}

export function CompleteTimeAndMaterialProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteTimeAndMaterialProjectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function CompleteTimeAndMaterialProjectRequestToJSON(value?: CompleteTimeAndMaterialProjectRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
    };
}

